module.exports = __webpack_public_path__ + "img/6-2.a7b02f27.jpg";